import React from 'react';
import * as S from './styles';

const PriceListPlaceholder = () => (
  <S.PlaceholderRow>
    <S.ShopPlaceholder />
    <S.StockAndPricePlaceholder />
    <S.CallToActionPlaceholder />
  </S.PlaceholderRow>
);

export default PriceListPlaceholder;
